import { Component, inject, signal } from '@angular/core';

import {
  ButtonComponent,
  CardComponent,
  IconComponent,
} from '@webapp/ui';
import { ActivatedRoute } from '@angular/router';
import { CHANNEL_QUOTE_ENUM } from '@webapp/core/config';
import { QuoterService } from '@webapp/quoter/services/quoter.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-payment-link-success-page',
  standalone: true,
  imports: [
    CardComponent,
    IconComponent,
    ButtonComponent
  ],
  templateUrl: './payment-link-success-page.component.html',
  styleUrl: './payment-link-success-page.component.scss',
})
export class PaymentLinkSuccessPageComponent {
  private quoterService = inject(QuoterService);
  route = inject(ActivatedRoute);
  quoteId = this.route.snapshot.queryParamMap.get('quoteId');
  channel = this.route.snapshot.queryParamMap.get('channel');
  loading = signal(false);
  readonly policyId = this.resolvePolicyId();

  isAppClient(){
    return this.channel === CHANNEL_QUOTE_ENUM.APP;
  }

  canDownload(): boolean {
    return !!this.quoteId || !!this.policyId;
  }

  async download() {
    if (!this.canDownload()) {
      return;
    }

    this.loading.set(true);
    const blob = await firstValueFrom(
      this.quoteId
        ? this.quoterService.downloadCertificateFromQuote(this.quoteId)
        : this.quoterService.downloadCertificate(this.policyId ?? '')
    );
    this.loading.set(false);

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `certificado_${this.policyId ?? this.quoteId}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  private resolvePolicyId(): string | null {
    const localPolicy = localStorage.getItem('activar_policy');
    if (!localPolicy) {
      return null;
    }

    try {
      const response = JSON.parse(localPolicy);
      return response?.policies?.[0]?.id ?? null;
    } catch {
      return null;
    }
  }
}
